"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./SponsoredListingHowItWorks.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-197":{"id":"e-197","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-198"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"6ec3a95f-ed1b-fe4e-9918-0bba21ecb84b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6ec3a95f-ed1b-fe4e-9918-0bba21ecb84b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":150,"direction":"BOTTOM","effectIn":true},"createdOn":1693249096187},"e-199":{"id":"e-199","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-200"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"6ec3a95f-ed1b-fe4e-9918-0bba21ecb84b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6ec3a95f-ed1b-fe4e-9918-0bba21ecb84b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1693249096187},"e-201":{"id":"e-201","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-202"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".step-block-1","originalId":"64d4176945b14c63e533db3c|9ea5487d-2a8a-3b55-5a6d-14d36ca2cd39","appliesTo":"CLASS"},"targets":[{"selector":".step-block-1","originalId":"64d4176945b14c63e533db3c|9ea5487d-2a8a-3b55-5a6d-14d36ca2cd39","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":50,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1611337298036},"e-203":{"id":"e-203","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-12","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-204"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".step-block-1","originalId":"64d4176945b14c63e533db3c|9ea5487d-2a8a-3b55-5a6d-14d36ca2cd5c","appliesTo":"CLASS"},"targets":[{"selector":".step-block-1","originalId":"64d4176945b14c63e533db3c|9ea5487d-2a8a-3b55-5a6d-14d36ca2cd5c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":50,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1611755066275}},"actionLists":{"a-11":{"id":"a-11","title":"Scroll-Content 2","actionItemGroups":[{"actionItems":[{"id":"a-11-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".bg-shadow","selectorGuids":["e2b4b95c-1493-93f0-e890-da15b77fb7d5"]},"value":"none"}},{"id":"a-11-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".dot-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bd"]},"globalSwatchId":"1730333e","rValue":238,"bValue":244,"gValue":239,"aValue":1}},{"id":"a-11-n-3","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".dot-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bd"]},"widthValue":12,"heightValue":12,"widthUnit":"px","heightUnit":"px","locked":false}},{"id":"a-11-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".img-block","selectorGuids":["e2b4b95c-1493-93f0-e890-da15b77fb7d7"]},"value":0.4,"unit":""}},{"id":"a-11-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".content-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bc"]},"globalSwatchId":"1f0d510e","rValue":71,"bValue":87,"gValue":74,"aValue":1}},{"id":"a-11-n-6","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{},"globalSwatchId":"","rValue":173,"bValue":194,"gValue":180,"aValue":1}},{"id":"a-11-n-7","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{},"globalSwatchId":"1f0d510e","rValue":71,"bValue":87,"gValue":74,"aValue":1}},{"id":"a-11-n-8","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".step-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bf"]},"globalSwatchId":"1730333e","rValue":238,"bValue":244,"gValue":239,"aValue":1}}]},{"actionItems":[{"id":"a-11-n-9","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":600,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".content-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bc"]},"globalSwatchId":"0b375fce","rValue":18,"bValue":18,"gValue":18,"aValue":1}},{"id":"a-11-n-10","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":600,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".dot-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bd"]},"globalSwatchId":"624cfa08","rValue":254,"bValue":85,"gValue":95,"aValue":1}},{"id":"a-11-n-11","actionTypeId":"STYLE_SIZE","config":{"delay":600,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".dot-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bd"]},"widthValue":24,"heightValue":24,"widthUnit":"px","heightUnit":"px","locked":false}},{"id":"a-11-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":600,"easing":"","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".img-block","selectorGuids":["e2b4b95c-1493-93f0-e890-da15b77fb7d7"]},"value":1,"unit":""}},{"id":"a-11-n-13","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":600,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".step-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bf"]},"globalSwatchId":"50035ee0","rValue":255,"bValue":255,"gValue":255,"aValue":1}},{"id":"a-11-n-14","actionTypeId":"GENERAL_DISPLAY","config":{"delay":600,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".bg-shadow","selectorGuids":["e2b4b95c-1493-93f0-e890-da15b77fb7d5"]},"value":"block"}},{"id":"a-11-n-15","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":600,"easing":"","duration":200,"target":{},"globalSwatchId":"624cfa08","rValue":254,"bValue":85,"gValue":95,"aValue":1}},{"id":"a-11-n-16","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":600,"easing":"","duration":200,"target":{},"globalSwatchId":"e5674d92","rValue":112,"bValue":138,"gValue":118,"aValue":1}}]}],"useFirstGroupAsInitialState":true,"createdOn":1611336400626},"a-12":{"id":"a-12","title":"Scroll Line 2","actionItemGroups":[{"actionItems":[{"id":"a-12-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".scroll-animate-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bb"]},"xValue":1,"yValue":0,"locked":false}}]},{"actionItems":[{"id":"a-12-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"","duration":600,"target":{"useEventTarget":"CHILDREN","selector":".scroll-animate-2","selectorGuids":["80011641-3723-35e8-0466-f939add599bb"]},"xValue":1,"yValue":1,"locked":false}}]}],"useFirstGroupAsInitialState":true,"createdOn":1611752162523},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SponsoredListingHowItWorks({
  as: _Component = _Builtin.Section,
}) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "sponsored-listing-how-it-works")}
      grid={{
        type: "section",
      }}
      tag="section"
      id="SponsoredListingHowItWorks"
    >
      <_Builtin.BlockContainer
        grid={{
          type: "container",
        }}
        tag="div"
      >
        <_Builtin.Heading
          className={_utils.cx(_styles, "sponsored-listings-faq-heading-text")}
          data-w-id="6ec3a95f-ed1b-fe4e-9918-0bba21ecb84b"
          tag="h2"
        >
          {"How it works"}
        </_Builtin.Heading>
      </_Builtin.BlockContainer>
      <_Builtin.Block className={_utils.cx(_styles, "content-block")} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, "steps-clone")} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, "step-block-1", "less-padding")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "img-block", "desktop")}
              tag="div"
            >
              <_Builtin.Image
                loading="lazy"
                width="400"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8ed6882b02434734ca8ba_1-create-listing.png"
              />
            </_Builtin.Block>
            <_Builtin.Block className={_utils.cx(_styles, "dot-2")} tag="div" />
            <_Builtin.Block
              className={_utils.cx(_styles, "content-wrap")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "step-content-block")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "step-2")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "content-2")}
                      tag="div"
                    >
                      <_Builtin.Heading
                        className={_utils.cx(_styles, "heading-5")}
                        tag="h4"
                      >
                        {"1. Create a listing & get verified"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "step-paragraph")}
                      >
                        {
                          "Quickly & easily create eye-catching listings with detailed templates and AI tools. When you're done, verify your profile and listing to attract up to 70% more renters."
                        }
                      </_Builtin.Paragraph>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "step-paragraph")}
                      >
                        <_Builtin.Link
                          button={false}
                          id="sl-anchor-postlisting"
                          block=""
                          options={{
                            href: "/boost-a-listing?accountType=essentials",
                            target: "_blank",
                          }}
                        >
                          {"Post a listing"}
                        </_Builtin.Link>
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "bg-shadow")}
                  tag="div"
                />
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "img-block")}
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-4")}
                  loading="lazy"
                  width="400"
                  height="auto"
                  alt=""
                  src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8ed6882b02434734ca8ba_1-create-listing.png"
                />
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "step-block-1", "secondstep")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "scoll-wrap")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "scroll-animate-2",
                  "mobile-reach"
                )}
                tag="div"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "scroll-base")}
                tag="div"
              />
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "content-wrap")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "step-content-block")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "step-2")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "content-2")}
                      tag="div"
                    >
                      <_Builtin.Heading tag="h4">
                        {"2. Boost your listing"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "step-paragraph")}
                      >
                        {
                          "Find qualified tenants faster with Sponsored Listings from liv.rent. Customize when, and for how long your listing will appear at the top of renters' search results with flexible pricing packages."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "bg-shadow")}
                  tag="div"
                />
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "dot-2", "second")}
              tag="div"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "img-block")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "image-5", "no-padding")}
                loading="lazy"
                width="400"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8eea8f1b56c7666e7720e_2-boost-listing.webp"
              />
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "step-block-1", "padding-bottom")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "img-block")}
              tag="div"
            >
              <_Builtin.Image
                loading="lazy"
                width="400"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8ed7e47f927220add8d41_3-leads.png"
              />
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "dot-2", "third")}
              tag="div"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "content-wrap")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "step-content-block")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "step-2")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "content-2")}
                      tag="div"
                    >
                      <_Builtin.Heading tag="h4">
                        {"3. Watch your inquiries skyrocket!"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "step-paragraph")}
                      >
                        {
                          "Sponsored Listings receive up to 65% more inquiries from qualified, ID-verified tenants, helping you fill vacancies fast."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "bg-shadow")}
                  tag="div"
                />
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "scoll-wrap")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "scroll-animate-2")}
                tag="div"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "scroll-base")}
                tag="div"
              />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
